import React from 'react';
import RateSysAdminParams from './RateSysAdminParams';
import RateSysAdminResults from './RateSysAdminResults';
import RateSysAdminList from './RateSysAdminList';


class RateSysAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedView: 'params'
    };
  }

  render() {
    //console.log('RateSysAdmin: render');
    const { bRateSysExists } = this.props;

    return (
      <div style={{ minHeight: '600px' }}>
        {bRateSysExists ? this.showRateSysAdminSection() : this.showSectionNotAvailable() }
      </div>
    );
  }

  showRateSysAdminSection() {
    const { selectedView } = this.state;
    return(
      <div>
        <div className="row">
        <div className="col-md-12">
          <h5>Système de cotation</h5>
        </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <button
              className={`btn ${selectedView === 'params' ? 'btn-primary' : 'btn-secondary'} width175px btn-margin-right-20`}
              onClick={() => this.setState({ selectedView: 'params' })}>
              Paramètres
            </button>
            <button
              className={`btn ${selectedView === 'results' ? 'btn-primary' : 'btn-secondary'} width175px btn-margin-right-20`}
              onClick={() => this.setState({ selectedView: 'results' })}>
              Résultats
            </button>
            <button
              className={`btn ${selectedView === 'list' ? 'btn-primary' : 'btn-secondary'} width175px btn-margin-right-20`}
              onClick={() => this.setState({ selectedView: 'list' })}>
              Listes complètes
            </button>
          </div>
        </div>
        <br />
        {this.renderSelectedComponent()}
      </div>
    )
  }

  renderSelectedComponent() {
    const { selectedView } = this.state;
    const { season } = this.props;

    if (selectedView === 'params') return <RateSysAdminParams season={season} />;
    if (selectedView === 'results') return <RateSysAdminResults season={season} />;
    if (selectedView === 'list') return <RateSysAdminList season={season} />;
    return null;
  }

  showSectionNotAvailable() {
    return ( <div> <p> Aucun système de cotation pour cette ligue </p> </div> )
  }

}

export default RateSysAdmin;
